import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getActionCenter } from '../../../feature/dashboard/DashboardSlice'

const STATUS = {
    ALL: '',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    PROGRESSED: 'PROGRESSED',
    CLOSED: 'CLOSED',
}



const statusStyle = {
    PENDING: { color: '#f59e0b', bg: '#fffbeb' },
    APPROVED: { color: '#22c55e', bg: '#f0fdf4' },
    PROGRESSED: { color: '#6366f1', bg: '#eef2ff' },
    CLOSED: { color: '#94a3b8', bg: '#f8fafc' },
}

function ActionCenter({ month, year }) {
    const dispatch = useDispatch()
    const { actionCenter, countStatus } = useSelector((state) => state.dashboards)
    const [activeTab, setActiveTab] = useState(STATUS.ALL)
    const { PENDING, PROGRESSED, CLOSED, APPROVED } = countStatus || {}
    console.log("countStatus", countStatus)

    const tabs = [
        {
            label: "All",
            value: STATUS.ALL,
            count: PENDING + PROGRESSED + CLOSED + APPROVED,
        },
        {
            label: "Pending",
            value: STATUS.PENDING,
            count: PENDING,
        },
        {
            label: "Approved",
            value: STATUS.APPROVED,
            count: APPROVED,
        },
        {
            label: "Progressed",
            value: STATUS.PROGRESSED,
            count: PROGRESSED,
        },
        {
            label: "Closed",
            value: STATUS.CLOSED,
            count: CLOSED,
        },
    ];

    useEffect(() => {
        dispatch(getActionCenter({ month, year, status: activeTab || undefined }))
    }, [month, year, activeTab])

    const list = Array.isArray(actionCenter) ? actionCenter : []

    const tabCounts = tabs.reduce((acc, t) => {
        acc[t.value] = t.value === STATUS.ALL
            ? list.length
            : list.filter(i => i.enquiryStatus === t.value).length
        return acc
    }, {})

    return (
        <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', border: '1px solid #f0f0f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#111' }}>Action Center</span>
                    <span style={{ background: '#fef2f2', color: '#ef4444', borderRadius: 20, padding: '2px 10px', fontSize: 12, fontWeight: 600 }}>{list.length} open</span>
                </div>
                <span style={{ fontSize: 13, color: '#6366f1', cursor: 'pointer', fontWeight: 500 }}>View queue</span>
            </div>

            {/* Filter Tabs */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
                {tabs.map((t, i) => (
                    <button key={i} onClick={() => setActiveTab(t.value)}
                        style={{ border: 'none', cursor: 'pointer', borderRadius: 20, padding: '5px 14px', fontSize: 13, fontWeight: 600, background: activeTab === t.value ? '#6366f1' : '#f5f5f5', color: activeTab === t.value ? '#fff' : '#555', display: 'flex', alignItems: 'center', gap: 5 }}>
                        {t.label}
                        <span style={{ background: activeTab === t.value ? 'rgba(255,255,255,0.25)' : '#e5e7eb', borderRadius: 10, padding: '0 6px', fontSize: 11 }}>
                            {t.count}
                        </span>
                    </button>
                ))}
            </div>

            {list.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px 0', color: '#bbb' }}>
                    <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>No actions for this period</div>
                </div>
            ) : (
                <table style={{ maxHeight: "100vh", overflowY: "auto", width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                            {['DAYCARE', 'STUDENTS', 'TEACHERS', 'ADMINS', 'CONTACT', 'DATE', 'STATUS', ''].map(h => (
                                <th key={h} style={{ textAlign: 'left', fontSize: 11, color: '#aaa', fontWeight: 600, padding: '6px 8px', letterSpacing: 0.5 }}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item) => {
                            const s = statusStyle[item.enquiryStatus] || { color: '#888', bg: '#f5f5f5' }
                            return (
                                <tr key={item._id} style={{ borderBottom: '1px solid #fafafa' }}>
                                    <td style={{ padding: '12px 8px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <div style={{ width: 32, height: 32, borderRadius: 8, background: '#eef2ff', color: '#6366f1', fontWeight: 700, fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                {item.initials}
                                            </div>
                                            <div style={{ fontWeight: 600, fontSize: 13, color: '#111' }}>{item.daycareName}</div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px 8px', fontSize: 13, color: '#333', fontWeight: 500 }}>{item.numberOfStudents}</td>
                                    <td style={{ padding: '12px 8px', fontSize: 13, color: '#333', fontWeight: 500 }}>{item.numberOfTeachers}</td>
                                    <td style={{ padding: '12px 8px', fontSize: 13, color: '#333', fontWeight: 500 }}>{item.numberOfAdmins}</td>
                                    <td style={{ padding: '12px 8px', fontSize: 12, color: '#555' }}>{item.mobileNo}</td>
                                    <td style={{ padding: '12px 8px', fontSize: 12, color: '#888' }}>{item.addedDate}</td>
                                    <td style={{ padding: '12px 8px' }}>
                                        <span style={{ background: s.bg, color: s.color, borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 }}>
                                            {item.enquiryStatus.charAt(0) + item.enquiryStatus.slice(1).toLowerCase()}
                                        </span>
                                    </td>
                                    <td style={{ padding: '12px 8px', color: '#ccc', cursor: 'pointer', fontSize: 16 }}>›</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default ActionCenter
